import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { StyledWrapper } from './Alert.style';
const icons = {
    success: 'checkbox---circle',
    error: 'alert---triangle',
    warning: 'alert-info',
    info: 'alert-info',
};
export function Alert({ message, type }) {
    const theme = useTheme();
    const themeIcons = Object.assign(Object.assign({}, icons), { info: theme.Components.Alert.Info.Icon });
    return (_jsxs(StyledWrapper, { type: type, children: [_jsx(Icon, { name: themeIcons[type], size: "Medium" }), _jsx(Text, { size: "Small", children: message })] }));
}
//# sourceMappingURL=Alert.js.map